import { useState } from "react";
import { Table } from "react-bootstrap";
import { currencyFormat } from "../../../helpers/numericFields";
import { EditLodgingRoomCategory } from "./EditLodgingRoomCategory";
import styles from './LodgingRoomCategoryDetails.module.css'

export const LodgingRoomCategoryDetails = ({ lodging, groupFile }) => {
  const [editRoom, setEditRoom] = useState(false)
  const [lodgingRoomCategorySelected, setLodgingRoomCategorySelected] = useState({});

  const editRoom2 = (room) => {
    setEditRoom(true);
    setLodgingRoomCategorySelected(room)
  }

  return (
    <div style={{ marginTop: 20, marginBottom: 50, border: "1 solid gray", background: "white", padding: 20 }}>
      <div className={`${styles.title}`}>Hospedaje: {lodging.name}</div>
      <div className="table-responsive">
        <Table className="table border text-nowrap text-md-nowrap mg-b-0">
          <thead>
            <tr>
              <th>Categoria</th>
              <th>Cantidad</th>
              <th>Editar</th>
            </tr>
          </thead>
          <tbody>
            {
              lodging.rooms.map(item => (
                <tr key={item.id}>
                  <td>{item.roomCategory}</td>
                  <td>{item.quantity}</td>            
                  <td style={{ textAlign: "center" }}>
                    <i className={`fe fe-edit ${styles.edit}`} onClick={() => editRoom2(item)}></i>
                  </td>
                </tr>))
            }
          </tbody>
        </Table>
      </div>
      <EditLodgingRoomCategory lodgingGroupRoomCategory={lodgingRoomCategorySelected} lodging={lodging} groupFile={groupFile} isOpen={editRoom} setIsOpen={setEditRoom} />
    </div>
  )
}
